export class Subscriptions {
    constructor() {
        this.executors = [];
    }
    subscribe(func) {
        if (typeof func === 'function') {
            this.executors.push(func);
            return true;
        }
        else {
            return false;
        }
    }
    execute(data) {
        this.executors.length &&
            this.executors.forEach((executor) => {
                if (typeof executor === 'function') {
                    executor(data);
                }
            });
    }
    unsubscribe(func) {
        this.executors = this.executors.filter((ex) => ex !== func);
    }
}
// this subscription is executed when user is click on button "End call"
// in pq-detail-desktop-wrapper or pq-mobile-main-box
export const personManuallyRemovedFromCallSub = new Subscriptions();
//this subscription is executed when user is click on button end call
//( button with red phone in call-actions__box)
export const callEndedByDoctorManuallySubscription = new Subscriptions();
//this subscription is executed when patient is click on button end call
//( button with red phone in call-actions__box)
export const callEndedByPatientManuallySubscription = new Subscriptions();
//this subscription is executed when provider closed tab
export const doctorLeftSubscription = new Subscriptions();
//this subscription is executed when session disconnected
export const activeProviderEndReasonSubscription = new Subscriptions();
//this subscription is executed when provider is click on button hold call
export const callOnHoldSubscription = new Subscriptions();
//this subscription is executed when patient received PAUSED event after provider put call on hold
export const callPausedForPatientSubscription = new Subscriptions();
//this subscription is executed when angular modal component opened
export const angularModalOpenedSubscription = new Subscriptions();
//this subscription is executed when angular modal component closed
export const angularModalClosedSubscription = new Subscriptions();
//this subscription is executed when person added to group call
export const personAddedToGroupCallSubscription = new Subscriptions();
//this subscription is executed when call is started
export const sessionConnectedSubscription = new Subscriptions();
//this subscription is executed when call is ended
export const sessionDisconnectedSubscription = new Subscriptions();
//this subscription is executed when screen sharing is updated
export const screenSharingUpdatedSubscription = new Subscriptions();
//this subscription is executed when screen sharing is started
export const screenSharingStartedSubscription = new Subscriptions();
//this subscription is executed when screen publisher starts with an error
export const screenPublisherErrorSubscription = new Subscriptions();
